import { render, staticRenderFns } from "./HotelsAdvancedDetailAdditional.vue?vue&type=template&id=a821b01e&"
import script from "./HotelsAdvancedDetailAdditional.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports